import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { locales, defaultLocale, parseLocale } from '@/locales'
import useIEHelper from '@/commons/ie-helper'
const { URLSearchParamsWrapper } = useIEHelper()

Vue.use(VueI18n)

const messages = locales.reduce((output, { code }) => {
  try {
    output[code] = require(`@/locales/${code}.json`)
  } catch (ex) {
    Vue.$log.log(ex)
    output[code] = {}
  }

  return output
}, {})

let urlParams = URLSearchParamsWrapper(window.location.search)
let hl = urlParams.get('hl')
let locale = defaultLocale.code
if (!hl) {
  if (navigator !== 'undefined') {
    locale = navigator.userLanguage ||
      navigator.language ||
      navigator.browserLanguage ||
      navigator.systemLanguage ||
      locale
    if (locale.length !== 5) {
      locale = (parseLocale(locale).code || defaultLocale.code)
    }
  }
} else {
  locale = (parseLocale(hl).code || defaultLocale.code)
}

let url = window.location.href.split('?')[0]
let query = window.location.href.split('?')[1] ? '' + window.location.href.split('?')[1] : ''
query = query !== '' ? query.split('&') : []
query = query.map(item => {
  if (item.split('=')[0] === 'hl') {
    return 'hl=' + locale
  }
  return item
})
if (!query.includes('hl=' + locale)) {
  query.push('hl=' + locale)
}
query = '?' + query.join('&')

window.history.replaceState(null, '', url + query)
const i18n = new VueI18n({
  locale: locale,
  fallbackLocale: defaultLocale.code,
  messages
})

export default i18n
